module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGGyumaoC-020da9d6ab98d6dce5a9bc19e627c2fa.png";